import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    booleanAttribute,
    forwardRef,
    input,
    model,
    output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

let inputId = 0;

@Component({
    selector: 'ui-input-checkbox',
    templateUrl: './m020-c060-input-checkbox.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ReactiveFormsModule, NgClass],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => M020C060InputCheckboxComponent), multi: true },
    ],
})
export class M020C060InputCheckboxComponent implements ControlValueAccessor {
    checked = model(false);
    disabled = input(false, { transform: booleanAttribute });
    asBadge = input(false, { transform: booleanAttribute });

    trackCheckbox = output();

    onChange?: (value: boolean) => void;
    onTouch?: () => void;

    registerOnChange(fn: (value: boolean) => void) {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void) {
        this.onTouch = fn;
    }

    writeValue(value: boolean) {
        this.checked.set(value);
    }

    onModelChange(value: boolean) {
        this.trackCheckbox.emit();
        this.checked.set(value);
        this.onChange?.(value);
        this.onTouch?.();
    }

    inputId = `form-input-checkbox-${inputId++}`;
}
